import moment from 'moment';

export function isStatsDetail(history: any) {
  return history?.location?.pathname === '/opinion/Stats/Detail';
}

export function handleViewMore(channelType: any, history: any) {
  const map: any = {
    social: 'socialMedia',
    comments: 'gameStore',
    news: 'newMedia',
  };
  history.push(`/opinion/Feeds/Feeds?tab=${map[channelType]}`);
}

export function getNewStatsDetailFilter({
  statsDetailType,
  filter,
  dataType,
  params,
  chartData,
}: any) {
  const curFilter = { ...filter };
  if (params.seriesType === 'pie') {
    if (dataType === 'version') {
      const { version_times } = filter;
      const { name } = params;
      const newVersionTimes = version_times?.filter(
        (item: any) => item.version_name === name,
      );
      curFilter[dataType] = newVersionTimes.map(
        (item: any) => item.release_time,
      );
      // curFilter.version_times = newVersionTimes || [];
    } else {
      const value = params.data.originName;
      curFilter[dataType] = value ? [value] : [];
    }
  }

  if (params.seriesType === 'scatter') {
    if (dataType === 'version') {
      const { version_times } = filter;
      const { name } = params;
      const newVersionTimes = version_times?.filter(
        (item: any) => item.version_name === name,
      );
      curFilter[dataType] = newVersionTimes.map(
        (item: any) => item.release_time,
      );
    } else {
      curFilter[dataType] = [params.name];
    }
  }

  if (params.seriesType === 'line') {
    const startTimeOrigin = params.name;
    const { date_type } = curFilter;

    const { start_time, end_time } = getStatsDetailTimeScope(
      date_type,
      startTimeOrigin,
    );

    if (
      start_time &&
      end_time &&
      moment(start_time).isValid() &&
      moment(end_time).isValid()
    ) {
      curFilter.start_time = start_time;
      curFilter.end_time = end_time;
    } else if (statsDetailType === 'stats-sentiment') {
      curFilter[dataType] = [params?.data?.originName];
    } else {
      // 不是时间的情况下，直接赋值
      curFilter[dataType] = [params.name];
    }
  }

  if (params.seriesType === 'bar') {
    const startTimeOrigin = params.name;
    const { date_type } = curFilter;

    const { start_time, end_time } = getStatsDetailTimeScope(
      date_type,
      startTimeOrigin,
    );

    if (
      start_time &&
      end_time &&
      moment(start_time).isValid() &&
      moment(end_time).isValid()
    ) {
      curFilter.start_time = start_time;
      curFilter.end_time = end_time;
    } else if (statsDetailType === 'stats-sentiment') {
      if (dataType === 'version') {
        const { version_times } = filter;
        const { name } = params;
        const newVersionTimes = version_times?.filter(
          (item: any) => item.version_name === name,
        );
        curFilter[dataType] = newVersionTimes.map(
          (item: any) => item.release_time,
        );
      } else {
        curFilter[dataType] = [params?.data?.originName];
      }
    } else {
      // 不是时间的情况下，直接赋值
      curFilter[dataType] = [params.name];
    }
  }

  if (dataType === 'topic') {
    if (curFilter?.topic?.[0] === 'Unlabeled reviews') {
      curFilter.topic = ['Other'];
    }

    if (curFilter?.topic?.[0] === 'Others') {
      const exceptTopics = chartData?.defaultLegend?.filter(
        (item: string) => item !== 'Others',
      );
      curFilter.except_topics = [...(exceptTopics || []), 'other'];
      curFilter.topic = [];
    } else {
      curFilter.except_topics = [];
    }
  }

  if (dataType === 'language') {
    if (curFilter?.language?.[0] === 'Others') {
      curFilter.except_language =
        chartData?.defaultLegend?.filter((item: string) => item !== 'Others') ||
        [];
      curFilter.language = [];
    } else {
      curFilter.except_language = [];
    }

    if (statsDetailType === 'steam-ratings-language') {
      curFilter.reviews_rating = params?.reviewsRating ? [params.reviewsRating] : [];
    }
  }

  if (dataType === 'channel') {
    if (curFilter?.channel?.[0] === 'Others') {
      curFilter.except_channels =
        chartData?.defaultLegend?.filter((item: string) => item !== 'Others') ||
        [];
      curFilter.channel = [];
    } else {
      curFilter.except_channels = [];
    }
  }

  if (dataType === 'keyword') {
    const mentions = (chartData?.mentions || []).filter((item: any) =>
      curFilter?.keyword?.includes(item.name),
    );
    const keywords = mentions
      .map((item: any) => item?.child || [])
      .flat(Infinity);
    if (keywords.length > 0) {
      curFilter.keyword = keywords;
    }
  }

  if (dataType === 'version') {
    if (params?.data?.originName === 'Others') {
      const { version_times } = filter;
      curFilter.except_versions =
        chartData?.defaultLegend
          ?.filter((item: string) => item !== 'Others')
          .map((ver: string) => {
            const newVersionTime = version_times?.find(
              (item: any) => item.version_name === ver,
            );
            return newVersionTime.release_time;
          }) || [];
      curFilter.version = version_times.map(
        (item: { release_time: any }) => item.release_time,
      );
    } else {
      curFilter.except_versions = [];
    }
  }

  // console.log('click params filter', filter);
  // console.log('click params dataType', dataType);
  // console.log('click params params', params, params.seriesType);
  // console.log('click params curFilter', curFilter);
  // console.log('click params chartData', chartData);
  // console.log('click params statsDetailType', statsDetailType);

  return curFilter;
}

export function getStatsDetailTimeScope(
  date_type: any,
  startTimeOrigin: string,
) {
  let start_time;
  let end_time;
  if (date_type === 'hourly') {
    start_time = moment(startTimeOrigin).format('YYYY-MM-DD HH:mm:ss');
    end_time = moment(startTimeOrigin)
      .add('1', 'hours')
      .format('YYYY-MM-DD HH:mm:ss');
  }

  if (date_type === 'daily') {
    start_time = moment(startTimeOrigin)
      .startOf('day')
      .format('YYYY-MM-DD HH:mm:ss');
    end_time = moment(startTimeOrigin)
      .endOf('day')
      .format('YYYY-MM-DD HH:mm:ss');
  }

  if (date_type === 'weekly') {
    start_time = moment(startTimeOrigin)
      .startOf('day')
      .format('YYYY-MM-DD HH:mm:ss');
    end_time = moment(startTimeOrigin)
      .add(1, 'week')
      .endOf('day')
      .format('YYYY-MM-DD HH:mm:ss');
  }

  if (date_type === 'monthly') {
    start_time = moment(startTimeOrigin)
      .startOf('day')
      .format('YYYY-MM-DD HH:mm:ss');
    end_time = moment(startTimeOrigin)
      .add(1, 'month')
      .endOf('day')
      .format('YYYY-MM-DD HH:mm:ss');
  }

  return {
    start_time,
    end_time,
  };
}
